import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const PageDisplayContainer = styled.h2`
    font-size:20px;
    margin-top:10px;
`;

const SearchResultsPageDisplay = ({
    currentPageStart,
    currentPageEnd,
    totalDocCount,
}) => (
    <PageDisplayContainer>Documents {currentPageStart} - {currentPageEnd} of {totalDocCount}</PageDisplayContainer>
);

SearchResultsPageDisplay.propTypes = {
    currentPageStart: PropTypes.number,
    currentPageEnd: PropTypes.number,
    totalDocCount: PropTypes.number,
}

export default SearchResultsPageDisplay;


// WEBPACK FOOTER //
// ./src/components/searchResults/components/searchResultsPageDisplay.js